<template>
    <div class="form-segment">
        <label for="password">Enter password*</label>
        <div class="lib-input-and-extra-container">
            <input
                :type="showPassword ? 'text' : 'password'"
                name="password"
                placeholder="Enter password"
                id="password"
                required
                data-msg-required="Please enter your password."/>
            <div class="lib-input-extra">
                <button @click="showPassword = !showPassword" type="button" class="visibility-button" tabindex="-1">
                    <i class="fa-regular" :class="{'fa-eye': !showPassword, 'fa-eye-slash': showPassword}"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PasswordInput',
    data: function() {
        return {
            showPassword: false,
        }
    }
};
</script>

<style lang="scss">
.lib-input-and-extra-container #password-error {
    position: absolute;
    top: 40px;
}
</style>

<style scoped lang="scss">
@import "../../../src/scss/prelude";

.lib-input-and-extra-container {
  position: relative;
  display: flex;
  align-items: end;
  width: 100%;
  max-width: 490px;

    .input-wrapper {
        width: 100%;
    }
}

.lib-input-extra {
    height: 40px;
    position: relative;
    padding: 0;
    cursor: pointer;

    color: $gray;

    &:hover {
        color: $darkgray;
    }

    > * {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 12px;
        width: 20px;
        padding: 0;
        text-align: center;
    }
}
</style>